import { z } from "zod";

export const STORED_HANDOVER_KEY = "msys.continueInvitation.handover";

const storedSchema = z.object({
  pairingId: z.string(),
  secret: z.string(),
  refToken: z.string(),
  savedAt: z.number(),
});

export type StoredHandover = z.infer<typeof storedSchema>;

/**
 * The claimed pairing's credentials, kept tab-scoped (sessionStorage) so a
 * hand-over registration that expires can renew its grant on this PC.
 * Returns false when storage is unavailable.
 */
export function writeStoredHandover(handover: StoredHandover): boolean {
  try {
    sessionStorage.setItem(STORED_HANDOVER_KEY, JSON.stringify(handover));
    return true;
  } catch {
    return false;
  }
}

export function readStoredHandover(): StoredHandover | null {
  try {
    const raw = sessionStorage.getItem(STORED_HANDOVER_KEY);
    if (raw === null) return null;
    const stored = storedSchema.safeParse(JSON.parse(raw));
    return stored.success ? stored.data : null;
  } catch {
    return null;
  }
}

export function deleteStoredHandover(): void {
  try {
    sessionStorage.removeItem(STORED_HANDOVER_KEY);
  } catch {
    // Storage unavailable: nothing was stored either.
  }
}
